var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.683 10.459h-.353V7.332C19.33 3.291 16.044 0 11.998 0 7.956 0 4.665 3.286 4.665 7.332c0 .373.299.671.671.671a.668.668 0 0 0 .671-.67c0-3.302 2.685-5.99 5.99-5.99 3.301 0 5.99 2.684 5.99 5.99v3.126H4.318c-.716 0-1.297.582-1.297 1.297v8.357A3.893 3.893 0 0 0 6.907 24h10.186a3.893 3.893 0 0 0 3.887-3.887v-8.357c0-.715-.582-1.297-1.297-1.297zm-.045 9.654a2.547 2.547 0 0 1-2.545 2.545H6.913a2.547 2.547 0 0 1-2.546-2.545V11.8h15.27v8.312z" }),
    React.createElement("path", { d: "M12.002 19.84a2.513 2.513 0 0 0 2.51-2.511 2.513 2.513 0 0 0-2.51-2.51 2.513 2.513 0 0 0-2.51 2.51 2.513 2.513 0 0 0 2.51 2.51zm0-3.684a1.17 1.17 0 0 1 0 2.341 1.17 1.17 0 0 1 0-2.341z" })
  );
});